import React from 'react';
import './RestBanner.scss'

function RestBanner(props) {
    return (
      <section id="rest-banner">
        {/* <div className="rest-banner container">
            <div className="boxes">
                <div className="inner">
                  <h1 className="heading">{props.heading}</h1>
                  {props.subHeading? <p className="desc">{props.subHeading}</p> :null}​
              </div>
              <div className="images"><img src={props.img} alt="" width="300" height="200"/></div>
            </div>
        </div> */}
        <div className="images"><img src={props.img} alt={`${props.img.slice(2, -6)}_pics`}/></div>
      </section>
    );
}

export default RestBanner;